<template>
  <div>
    <div class="more-news block color-default">
      <h3 class="block-title">
        <span v-if="isWithinSearch">Dernières actualités</span>
        <span v-else>Résults pour "{{ $route.params.query }} "</span>
      </h3>
      <articles-query :tags="websiteTags" :query="$route.params.query">
        <template slot-scope="props">
          <div v-for="article in props.articles">
            <article-preview :article="article"></article-preview>
          </div>
        </template>
      </articles-query>
    </div>
    <br /><br />
    <read-more/>

  </div>
</template>

<script>
  import { ArticlesQuery, TopArticles } from 'itrnews-vuejs-api';
  import ArticlePreview from './elements/ArticlePreview';
  import SmallArticlePreview from './elements/SmallArticlePreview';
  import website from '../mixins/website';
  import ReadMore from './ReadMore';

  export default {
    name: 'LastArticles',
    components: { ReadMore, ArticlePreview, ArticlesQuery, TopArticles, SmallArticlePreview },
    mixins: [website],
    computed: {
      isWithinSearch() {
        return this.$route.params.query === undefined;
      },
    },
  };
</script>

<style>
  .small-article {
    min-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LastArticles.vue